module.exports = __webpack_public_path__ + "img/radio_off.5d93bd9b.svg";